
import { EntReservoirFilter } from "../../../models/filters/reservoirFilter";

import { EntReservoir } from "../../../models/reservoir";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";
export const reservoirApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getReservoirList: builder.query<ResponseDataGet<EntReservoir>, EntReservoirFilter>({
      query: (filter) => ({
        url: `${ Paths.reservoirs }/get-all`,
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getReservoirById: builder.query<ResponseDataTest<EntReservoir>, number>({
      query: (id) => ({
        url: `${ Paths.reservoirs }/${id}`,
        method: 'GET'
      })
    }),
    addReservoir: builder.mutation<ResponseDataTest<EntReservoir>, EntReservoir>({
      query: (body) => ({
        url: `${ Paths.reservoirs }`,
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editReservoir: builder.mutation<ResponseDataTest<EntReservoir>, EntReservoir>({
      query: (body) => ({
        url: `${ Paths.reservoirs }`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteReservoir: builder.mutation<ResponseDataTest<EntReservoir>, number>({
      query: (id) => ({
        url: `${ Paths.reservoirs }/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddReservoirMutation,
  useDeleteReservoirMutation,
  useEditReservoirMutation,
  useLazyGetReservoirListQuery,
  useGetReservoirListQuery
} = reservoirApi;
